export default __webpack_public_path__ + "static/media/digit_span_male_horizon.1bed8723.png";